var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 14,
    fill: "url(#paint0_linear_4199_45192)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7137 20.2816L22.3356 16.3301H18.4452V13.767C18.4452 12.6857 18.9877 11.6311 20.7302 11.6311H22.5V8.26699C22.5 8.26699 20.8945 8 19.3603 8C16.1548 8 14.0617 9.89294 14.0617 13.3184V16.3301H10.5V20.2816H14.0617V29.8345C14.7767 29.944 15.5082 30 16.2534 30C16.9986 30 17.7302 29.944 18.4452 29.8345V20.2816H21.7137Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4199_45192",
    x1: 16.5,
    y1: 2,
    x2: 16.5,
    y2: 29.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18ACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0163E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooFb);
export default __webpack_public_path__ + "static/media/fooFb.2a029d6e072e05f098c6d6d4a626f491.svg";
export { ForwardRef as ReactComponent };